'use strict';
import React from 'react';
import flux from 'utils/flux';
import AltContainer from 'alt-container';
import classnames from 'classnames';
import ShareItem from './shareItem';
import ShareItemRestricted from './shareItemRestricted';
import LoadingSpinner from 'components/spinner/spinner';
import ShareSidebar from './shareSidebar';
import HeaderBarShare from 'components/headerBar/headerShare';

var BasketPage = React.createClass({
    displayName: 'SharePage',
    mixins: [],
    propTypes: {},
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    statics: {
        willTransitionTo: function(transition, query) {
            const { shareMode } = flux.getStore('app').getState().config.toJS();
            if ('auth' === shareMode && !flux.getStore('app').isAuthenticated()) {
                return transition.redirect('/login', {}, {nextPath: transition.path});
            }

            if ('auth' === shareMode && !flux.getStore('app').hasAcceptedLatestTerms() ) {
                return transition.redirect( '/accept_terms', {}, {nextPath: transition.path} );
            }

            else {
                return flux.getStore('share').loadShare(query.shareId);
            }
        }
    },
    render() {
        var currentBasketId = this.props.params.basketId;
        var currentShareId = this.props.params.shareId;
        var router = this.context.router;
        const { shareMode } = flux.getStore('app').getState().config.toJS();
        const isAuthenticated = flux.getStore('app').isAuthenticated();
        return (
            <AltContainer stores={{shareStore: flux.getStore('share')}}
                render={props => {
                    const linkExpired = props.shareStore.linkExpired;
                    if (linkExpired) {
                        return (
                            <div className={classnames('page', { 'share--noauth': 'noAuth' === shareMode })}>
                                <div className={classnames( 'headerbar', { 'headerbar--empty': 'noAuth' === shareMode } )}>
                                    <div className="container--centered">
                                        <h4 className='error'>{flux.t('share_url_invalid')}</h4>
                                    </div>
                                </div>
                            </div>);
                    }

                    var ix = props.shareStore.baskets.findIndex((item) => item.get('id') === currentBasketId);
                    var currentBasket = props.shareStore.baskets.getIn([ix]);

                    if (flux.getStore('share').isLoading() || flux.getStore('modals').getState().loading) {
                        return <LoadingSpinner />;
                    }

                    if (!currentBasket || currentBasket.size === 0) {
                        router.transitionTo('landing-page');
                        return (<div />);
                    }

                    return (
                        <div className={classnames('page', 'share', { 'share--noauth': 'noAuth' === shareMode })}>
                            <div className={classnames( 'headerbar', { 'headerbar--empty': 'noAuth' === shareMode } )}>
                                <div className="container--centered">
                                    {('auth' === shareMode || 'openDownload' === shareMode || ('noAuth' === shareMode && isAuthenticated)) && <HeaderBarShare basket={currentBasket} />}
                                </div>
                            </div>

                            <div className="basket__container container--centered">
                                <div className="container__filters">
                                    <ShareSidebar user={props.shareStore.user} baskets={props.shareStore.baskets} shareId={currentShareId} />
                                </div>
                                <div className="container__content">
                                    {currentBasket.get('items').map( item => {
                                        if ( !item.get('visible') ) {
                                            return (<ShareItemRestricted key={item.get('id')} item={item} />);
                                        }
                                        return (<ShareItem key={item.get('id')} basketId={currentBasketId} item={item} />);
                                    })}
                                </div>
                            </div>
                        </div>
                    );
                }}>
            </AltContainer>
        );
    }
});

module.exports = BasketPage;



// WEBPACK FOOTER //
// ./app/pages/share/index.jsx